import React from "react";
import "./Internship_about.css";

function Internship_about({ data }) {
  console.log(data, "data");

  return (
    <>
      <section className="Internship_about">
        <div className="container">
          <div className="text_holder">
            <p>
              {data?.WebBelowWhatYouGet?.WebBelowWhatYouGet_Lang?.name ||
                `${data?.name} is a key destination in AFI’s global partner network.`}
            </p>
            <p>
              {data?.WebBelowWhatYouGet?.WebBelowWhatYouGet_Lang?.sub_title ||
                `Our ${data?.name} placements connect students to prestigious hotels, Michelin-recognized restaurants, Relais & Châteaux properties, spa resorts, and boutique maisons — offering structured training, cultural immersion, and professional growth.`}
            </p>
          </div>
        </div>
      </section>
    </>
  );
}

export default Internship_about;
